// extracted by mini-css-extract-plugin
module.exports = {"LdsRoller":"LoaderSection_LdsRoller__RACWm","lds-roller":"LoaderSection_lds-roller__2h6qi"};